<main class="auth-layout">
  <ng-content></ng-content>
</main>
